import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  CircularProgress,
} from '@material-ui/core';
import queryString from 'query-string';
import { Redirect } from 'react-router-dom';

import {
  validateCode,
} from '../../utils/api';

import {
  applyCookie,
} from '../../utils/cookies';

export default function RedirectPage({
  location,
}) {
  const [loading, setLoading] = useState(true);
  const [auth, setAuth] = useState(false);

  useEffect(() => {
    const { search } = location;

    const callback = (response) => {
      if (response.boxToken && response.cognitoToken) {
        const expiryTime = response.boxToken.acquiredAtMS + response.boxToken.accessTokenTTLMS;
        applyCookie('boxToken', JSON.stringify(response.boxToken), expiryTime);
        applyCookie('cognitoToken', JSON.stringify(response.cognitoToken));
        setAuth(true);
      }
      setLoading(false);
    };

    validateCode(queryString.parse(search).code, callback);
  }, []);

  if (!loading) {
    if (auth) {
      return (
        <Redirect
          to="/main"
        />
      );
    }
    return (
      <Redirect to="/" />
    );
  }

  return (
    <div className="tabs justify-center fill items-center" style={{ height: '100vh' }}>
      <CircularProgress style={{ width: 100, height: 100 }} />
      <p className="margin-top-30">Authenticating...</p>
    </div>
  );
}

RedirectPage.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};
